import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    name: 'Dra. María Ferreyra',
    role: 'Abogada especialista en Derecho del Consumidor · Córdoba',
    text: 'Tenía un reclamo bancario particularmente complejo por consumos no reconocidos. Los modelos y la jurisprudencia seleccionada me permitieron estructurar la demanda con solidez y resolver el caso en tiempo récord. Es material que se nota elaborado por alguien que litiga.',
    rating: 5
  }, {
    name: 'Dr. Juan Pérez',
    role: 'Titular del Estudio Pérez & Asociados · Buenos Aires',
    text: 'Incorporé el tratado al estudio y hoy es consulta obligada del equipo. Nos dio un método claro para pasar del reclamo administrativo a la instancia judicial y empezar a tomar casos de consumo con mucha más seguridad y previsibilidad.',
    rating: 5
  }, {
    name: 'Dra. Laura González',
    role: 'Abogada litigante · Rosario',
    text: 'La relación costo-beneficio es indiscutible: la inversión se recupera con el primer caso que resolvés. Los escritos editables y el kit de cartas documento me ahorran horas de redacción en cada expediente.',
    rating: 5
  }];
  return <section className="py-12 bg-legal-800" data-id="element-202">
      <div className="container mx-auto px-4" data-id="element-203">
        <div className="text-center mb-10" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-205">
            Lo que dicen nuestros clientes
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-206">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-900 p-8 rounded-xl border border-legal-700 relative" data-id="element-207">
              <div className="flex gap-1 mb-6" data-id="element-208">
                {[...Array(test.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-209" />)}
              </div>
              <p className="text-slate-300 mb-8 italic leading-relaxed" data-id="element-210">
                "{test.text}"
              </p>
              <div className="flex items-center gap-3 pt-6 border-t border-legal-700" data-id="element-211">
                <div className="flex items-center justify-center w-11 h-11 rounded-full bg-gold-500/10 border border-gold-500/30 text-gold-500 font-bold text-sm shrink-0" data-id="element-212">
                  {test.name.replace(/^Dr[a]?\.?\s/, '').split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
                <div data-id="element-213">
                  <p className="text-white font-bold leading-tight" data-id="element-214">
                    {test.name}
                  </p>
                  <p className="text-slate-400 text-xs leading-snug mt-0.5" data-id="element-215">
                    {test.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};